export class SessaoCliente
{
    public idUsuario: number;
    public idCliente: number;
    public nome: string;
    public grupo: string;
    public accessToken: string;
    public isComplete: boolean
}